import React from 'react';
import "./filterbar.css";
import "./responsive.css";
import { FiSearch } from "react-icons/fi";
import Dropdown from './Dropdown';

/*
  filters: [{ label, options: [], value, onChange }]
  Every option list is built by the page from the fields that already exist on
  the record, so nothing here assumes a field the database does not have.
*/
const FilterBar = ({ placeholder, search, setSearch, filters = [], shown, total }) => {

  const handleSubmit = (event) => event.preventDefault();

  const reset = () => {
    setSearch("");
    filters.forEach(filter => filter.onChange(""));
  }

  const dirty = search !== "" || filters.some(filter => filter.value !== "");

  return (
    <form className='filter-bar' onSubmit={handleSubmit}>
      <div className="filter-row fcs">
        <label className='search-box fcs'>
          <FiSearch />
          <input
            type='text'
            placeholder={placeholder}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </label>
        {
          filters.map((filter, i) => (
            <Dropdown
              key={i}
              label={filter.label}
              options={filter.options}
              value={filter.value}
              onChange={filter.onChange}
            />
          ))
        }
        {dirty && <button type='button' className='reset' onClick={reset}>reset</button>}
        <span className="count">showing <b>{shown}</b> of {total}</span>
      </div>
    </form>
  )
}

export default FilterBar
